import { lazy } from "react";

import {
    Setting2,
    I3Dcube,
    Lock,
    Profile2User,
    Star1,
    ShoppingBag,
    Tag,
    Gift,
    NotificationStatus,
    TableDocument,
    Category2,
    CpuSetting,
    Box1,
    Data,
    Chart2,
    MobileProgramming,
    Link2,
    Convertshape2,
    TaskSquare,
    Book,
    UserSquare,
    NotificationBing,
    Messages2,
    MagicStar,
    DocumentText,
    Gallery,
    ChartSquare,
} from "iconsax-react";

import { RouteItem, UserTypes } from "../../interfaces/routes.interface";
import AuthGuard from "../../layouts/AuthGuard";
import { ROUTES } from "../../constants/routes";
import createIconWrapper from "../../components/shared/IconWrapper";

// Use React's lazy for code splitting
const AdminDashboard = lazy(() => import("../../../modules/admin/dashboard"));
const Organizations = lazy(
    () => import("../../../modules/admin/organizations")
);
const PMDashboard = lazy(
    () => import("../../../modules/admin/pm-dashboard")
);
const MessageCenter = lazy(
    () => import("../../../modules/admin/message-center")
);
const Reports = lazy(() => import("../../../modules/admin/reports"));
const ReportSettings = lazy(
    () => import("../../../modules/admin/reports/settings")
);
const Organization = lazy(
    () => import("../../../modules/admin/organizations/Organization")
);
const OrganizationFeatures = lazy(
    () => import("../../../modules/admin/organizations/Features")
);
const OrganizationFirebaseSettings = lazy(
    () => import("../../../modules/admin/organizations/FirebaseSettings")
);
const OrganizationMobileAppAccounts = lazy(
    () => import("../../../modules/admin/organizations/MobileAppAccountsPage")
);
const OrganizationDefaultContentGenerator = lazy(
    () => import("../../../modules/admin/organizations/default-content-generator")
);
const Permissions = lazy(() => import("../../../modules/admin/permissions"));
const Roles = lazy(() => import("../../../modules/admin/roles"));
const Users = lazy(() => import("../../../modules/admin/users"));
const User = lazy(() => import("../../../modules/admin/users/User"));
const PortalUsers = lazy(() => import("../../../modules/admin/portal-users"));
const ProductSyncLogs = lazy(
    () => import("../../../modules/admin/sync-logs/ProductSyncLogs")
);
const PromotionSyncLogs = lazy(
    () => import("../../../modules/admin/sync-logs/PromotionSyncLogs")
);
const RewardSyncLogs = lazy(
    () => import("../../../modules/admin/sync-logs/RewardSyncLogs")
);
const NotificationLogs = lazy(
    () => import("../../../modules/admin/sync-logs/NotificationLogs")
);
const RegistrationAndVerificationLogs = lazy(
    () =>
        import(
            "../../../modules/admin/sync-logs/RegistrationAndVerificationLogs"
        )
);
const FeatureBundles = lazy(
    () => import("../../../modules/admin/feature-bundles")
);
const AiPlayground = lazy(
    () => import("../../../modules/admin/ai-playground")
);
const ImageGenerationSessions = lazy(
    () => import("../../../modules/admin/image-generation")
);
const ImagePromptVersions = lazy(
    () => import("../../../modules/admin/image-generation/PromptVersions")
);
const RedisCache = lazy(
    () => import("../../../modules/admin/redis-cache")
);
const Analytics = lazy(() => import("../../../modules/admin/analytics"));
const TenantAnalytics = lazy(
    () => import("../../../modules/admin/analytics/TenantAnalytics")
);
const AnalyticsEventRecords = lazy(
    () => import("../../../modules/admin/analytics/EventRecords")
);
const Brands = lazy(() => import("../../../modules/admin/brands"));
const AppStoreMonitor = lazy(
    () => import("../../../modules/admin/app-store-monitor")
);
const ResourceLinks = lazy(
    () => import("../../../modules/admin/resource-links")
);
const DocumentationLinks = lazy(
    () => import("../../../modules/admin/documentation-links")
);
const IntegrationTemplates = lazy(
    () => import("../../../modules/admin/integration-templates")
);
const IntegrationTemplateForm = lazy(
    () => import("../../../modules/admin/integration-templates/Form")
);
const Announcements = lazy(
    () => import("../../../modules/admin/announcements")
);
const AnnouncementForm = lazy(
    () => import("../../../modules/admin/announcements/Form")
);
const AnnouncementMetrics = lazy(
    () => import("../../../modules/admin/announcements/Metrics")
);


const userTypes = [UserTypes.admin];
const roles = [] as any;

export const overview: RouteItem = {
    name: "Overview",
    id: ROUTES.ADMIN.dashboard.key,
    path: ROUTES.ADMIN.dashboard.key,
    component: AdminDashboard,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Category2, { variant: "Linear" }),
    iconActive: createIconWrapper(Category2, { variant: "Bold" }),
};

export const analytics: RouteItem = {
    name: "Analytics",
    id: ROUTES.ADMIN.analytics.key,
    path: ROUTES.ADMIN.analytics.key,
    component: Analytics,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Chart2, { variant: "Linear" }),
    iconActive: createIconWrapper(Chart2, { variant: "Bold" }),
};

export const analyticsTenant: RouteItem = {
    name: "AnalyticsTenant",
    id: ROUTES.ADMIN.analytics_tenant.key,
    path: ROUTES.ADMIN.analytics_tenant.key,
    component: TenantAnalytics,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const analyticsEvents: RouteItem = {
    name: "AnalyticsEvents",
    id: ROUTES.ADMIN.analytics_events.key,
    path: ROUTES.ADMIN.analytics_events.key,
    component: AnalyticsEventRecords,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const analyticsTenantEvents: RouteItem = {
    name: "AnalyticsTenantEvents",
    id: ROUTES.ADMIN.analytics_tenant_events.key,
    path: ROUTES.ADMIN.analytics_tenant_events.key,
    component: AnalyticsEventRecords,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const organizations: RouteItem = {
    name: "Organizations",
    id: ROUTES.ADMIN.organizations.key,
    path: ROUTES.ADMIN.organizations.key,
    component: Organizations,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(I3Dcube, { variant: "Linear" }),
    iconActive: createIconWrapper(I3Dcube, { variant: "Bold" }),
};

export const pmDashboard: RouteItem = {
    name: "PM Dashboard",
    id: ROUTES.ADMIN.pm_dashboard.key,
    path: ROUTES.ADMIN.pm_dashboard.key,
    component: PMDashboard,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(TaskSquare, { variant: "Linear" }),
    iconActive: createIconWrapper(TaskSquare, { variant: "Bold" }),
};

// Staff only: AuthGuard admits admin-type users and the API additionally rejects tenant-bound accounts
export const reports: RouteItem = {
    name: "Reports",
    id: ROUTES.ADMIN.reports.key,
    path: ROUTES.ADMIN.reports.key,
    component: Reports,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(ChartSquare, { variant: "Linear" }),
    iconActive: createIconWrapper(ChartSquare, { variant: "Bold" }),
};

export const reportsSettings: RouteItem = {
    name: "ReportSettings",
    id: ROUTES.ADMIN.reports_settings.key,
    path: ROUTES.ADMIN.reports_settings.key,
    component: ReportSettings,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const messageCenter: RouteItem = {
    name: "Message Center",
    id: ROUTES.ADMIN.message_center.key,
    path: ROUTES.ADMIN.message_center.key,
    component: MessageCenter,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Messages2, { variant: "Linear" }),
    iconActive: createIconWrapper(Messages2, { variant: "Bold" }),
};

export const organizationsView: RouteItem = {
    name: "OrganizationsShow",
    id: ROUTES.ADMIN.organizations_view.key,
    path: ROUTES.ADMIN.organizations_view.key,
    component: Organization,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const organizationsFeature: RouteItem = {
    name: "OrganizationsFeature",
    id: ROUTES.ADMIN.organizations_features.key,
    path: ROUTES.ADMIN.organizations_features.key,
    component: OrganizationFeatures,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const organizationsFirebaseSettings: RouteItem = {
    name: "OrganizationsFirebaseSettings",
    id: ROUTES.ADMIN.organizations_firebase_settings.key,
    path: ROUTES.ADMIN.organizations_firebase_settings.key,
    component: OrganizationFirebaseSettings,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const organizationsMobileAppAccounts: RouteItem = {
    name: "OrganizationsMobileAppAccounts",
    id: ROUTES.ADMIN.organizations_mobile_app_accounts.key,
    path: ROUTES.ADMIN.organizations_mobile_app_accounts.key,
    component: OrganizationMobileAppAccounts,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const organizationsDefaultContentGenerator: RouteItem = {
    name: "OrganizationsDefaultContentGenerator",
    id: ROUTES.ADMIN.organizations_default_content_generator.key,
    path: ROUTES.ADMIN.organizations_default_content_generator.key,
    component: OrganizationDefaultContentGenerator,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const appStoreMonitor: RouteItem = {
    name: "App Monitor",
    id: ROUTES.ADMIN.app_store_monitor.key,
    path: ROUTES.ADMIN.app_store_monitor.key,
    component: AppStoreMonitor,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(MobileProgramming, { variant: "Linear" }),
    iconActive: createIconWrapper(MobileProgramming, { variant: "Bold" }),
};

export const permissions: RouteItem = {
    name: "Permissions",
    id: ROUTES.ADMIN.permissions.key,
    path: ROUTES.ADMIN.permissions.key,
    component: Permissions,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Lock, { variant: "Linear" }),
    iconActive: createIconWrapper(Lock, { variant: "Bold" }),
};

export const users: RouteItem = {
    name: "Admin Users",
    id: ROUTES.ADMIN.users.key,
    path: ROUTES.ADMIN.users.key,
    component: Users,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Profile2User, { variant: "Linear" }),
    iconActive: createIconWrapper(Profile2User, { variant: "Bold" }),
};

export const usersView: RouteItem = {
    id: ROUTES.ADMIN.users_view.key,
    path: ROUTES.ADMIN.users_view.key,
    component: User,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const portalUsers: RouteItem = {
    name: "Portal Users",
    id: ROUTES.ADMIN.portal_users.key,
    path: ROUTES.ADMIN.portal_users.key,
    component: PortalUsers,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(UserSquare, { variant: "Linear" }),
    iconActive: createIconWrapper(UserSquare, { variant: "Bold" }),
};

export const rolesList: RouteItem = {
    name: "Roles",
    id: ROUTES.ADMIN.roles.key,
    path: ROUTES.ADMIN.roles.key,
    component: Roles,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Star1, { variant: "Linear" }),
    iconActive: createIconWrapper(Star1, { variant: "Bold" }),
};

export const featureBundles: RouteItem = {
    name: "Feature Bundles",
    id: ROUTES.ADMIN.feature_bundles.key,
    path: ROUTES.ADMIN.feature_bundles.key,
    component: FeatureBundles,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Box1, { variant: "Linear" }),
    iconActive: createIconWrapper(Box1, { variant: "Bold" }),
};

export const integrationTemplates: RouteItem = {
    name: "Integration Templates",
    id: ROUTES.ADMIN.integration_templates.key,
    path: ROUTES.ADMIN.integration_templates.key,
    component: IntegrationTemplates,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Convertshape2, { variant: "Linear" }),
    iconActive: createIconWrapper(Convertshape2, { variant: "Bold" }),
};

export const integrationTemplatesCreate: RouteItem = {
    id: ROUTES.ADMIN.integration_templates_create.key,
    path: ROUTES.ADMIN.integration_templates_create.key,
    component: IntegrationTemplateForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const integrationTemplatesView: RouteItem = {
    id: ROUTES.ADMIN.integration_templates_view.key,
    path: ROUTES.ADMIN.integration_templates_view.key,
    component: IntegrationTemplateForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const settings: RouteItem = {
    name: "Settings",
    id: ROUTES.ADMIN.settings.key,
    path: ROUTES.ADMIN.settings.key,
    component: Roles,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Setting2, { variant: "Linear" }),
    iconActive: createIconWrapper(Setting2, { variant: "Bold" }),
    isSecondaryItem: true,
};

export const productSyncLogs: RouteItem = {
    name: "Product Syncs",
    id: ROUTES.ADMIN.product_sync_logs.key,
    path: ROUTES.ADMIN.product_sync_logs.key,
    component: ProductSyncLogs,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(ShoppingBag, { variant: "Linear" }),
    iconActive: createIconWrapper(ShoppingBag, { variant: "Bold" }),
};

export const promotionSyncLogs: RouteItem = {
    name: "Promotion Syncs",
    id: ROUTES.ADMIN.promotion_sync_logs.key,
    path: ROUTES.ADMIN.promotion_sync_logs.key,
    component: PromotionSyncLogs,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Tag, { variant: "Linear" }),
    iconActive: createIconWrapper(Tag, { variant: "Bold" }),
};

export const rewardSyncLogs: RouteItem = {
    name: "Reward Syncs",
    id: ROUTES.ADMIN.reward_sync_logs.key,
    path: ROUTES.ADMIN.reward_sync_logs.key,
    component: RewardSyncLogs,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Gift, { variant: "Linear" }),
    iconActive: createIconWrapper(Gift, { variant: "Bold" }),
};

export const notificationSentLogs: RouteItem = {
    name: "Notifications Sent",
    id: ROUTES.ADMIN.notification_logs.key,
    path: ROUTES.ADMIN.notification_logs.key,
    component: NotificationLogs,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(NotificationStatus, { variant: "Linear" }),
    iconActive: createIconWrapper(NotificationStatus, { variant: "Bold" }),
};

export const registrationAndVerificationLogs: RouteItem = {
    name: "Registrations & Verifications",
    id: ROUTES.ADMIN.registration_and_verifications_logs.key,
    path: ROUTES.ADMIN.registration_and_verifications_logs.key,
    component: RegistrationAndVerificationLogs,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Profile2User, { variant: "Linear" }),
    iconActive: createIconWrapper(Profile2User, { variant: "Bold" }),
};

export const logs: RouteItem = {
    name: "Logs",
    id: ROUTES.ADMIN.logs.key,
    path: ROUTES.ADMIN.logs.key,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(TableDocument, { variant: "Linear" }),
    iconActive: createIconWrapper(TableDocument, { variant: "Bold" }),
    subItems: [
        productSyncLogs,
        promotionSyncLogs,
        rewardSyncLogs,
        notificationSentLogs,
        registrationAndVerificationLogs,
    ],
};

export const aiPlayground: RouteItem = {
    name: "AI Playground",
    id: ROUTES.ADMIN.ai_playground.key,
    path: ROUTES.ADMIN.ai_playground.key,
    component: AiPlayground,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(CpuSetting, { variant: "Linear" }),
    iconActive: createIconWrapper(CpuSetting, { variant: "Bold" }),
};

export const imageGenerationSessions: RouteItem = {
    name: "Image Generation",
    id: ROUTES.ADMIN.image_generation_sessions.key,
    path: ROUTES.ADMIN.image_generation_sessions.key,
    component: ImageGenerationSessions,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Gallery, { variant: "Linear" }),
    iconActive: createIconWrapper(Gallery, { variant: "Bold" }),
};

export const imagePromptVersions: RouteItem = {
    name: "Image Prompt Versions",
    id: ROUTES.ADMIN.image_prompt_versions.key,
    path: ROUTES.ADMIN.image_prompt_versions.key,
    component: ImagePromptVersions,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(DocumentText, { variant: "Linear" }),
    iconActive: createIconWrapper(DocumentText, { variant: "Bold" }),
};

export const imageGeneration: RouteItem = {
    name: "AI Images",
    id: ROUTES.ADMIN.image_generation.key,
    path: ROUTES.ADMIN.image_generation.key,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(MagicStar, { variant: "Linear" }),
    iconActive: createIconWrapper(MagicStar, { variant: "Bold" }),
    subItems: [imageGenerationSessions, imagePromptVersions],
};

export const redisCache: RouteItem = {
    name: "Redis Cache",
    id: ROUTES.ADMIN.redis_cache.key,
    path: ROUTES.ADMIN.redis_cache.key,
    component: RedisCache,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Data, { variant: "Linear" }),
    iconActive: createIconWrapper(Data, { variant: "Bold" }),
};

export const brands: RouteItem = {
    name: "Brands",
    id: ROUTES.ADMIN.brands.key,
    path: ROUTES.ADMIN.brands.key,
    component: Brands,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Tag, { variant: "Linear" }),
    iconActive: createIconWrapper(Tag, { variant: "Bold" }),
};

export const announcements: RouteItem = {
    name: "Announcements",
    id: ROUTES.ADMIN.announcements.key,
    path: ROUTES.ADMIN.announcements.key,
    component: Announcements,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(NotificationBing, { variant: "Linear" }),
    iconActive: createIconWrapper(NotificationBing, { variant: "Bold" }),
};

export const announcementsCreate: RouteItem = {
    id: ROUTES.ADMIN.announcements_create.key,
    path: ROUTES.ADMIN.announcements_create.key,
    component: AnnouncementForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const announcementsEdit: RouteItem = {
    id: ROUTES.ADMIN.announcements_edit.key,
    path: ROUTES.ADMIN.announcements_edit.key,
    component: AnnouncementForm,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const announcementsMetrics: RouteItem = {
    id: ROUTES.ADMIN.announcements_metrics.key,
    path: ROUTES.ADMIN.announcements_metrics.key,
    component: AnnouncementMetrics,
    guard: AuthGuard,
    userTypes,
    roles,
    hidden: true,
};

export const resourceLinks: RouteItem = {
    name: "Resource Links",
    id: ROUTES.ADMIN.resourceLinks.key,
    path: ROUTES.ADMIN.resourceLinks.key,
    component: ResourceLinks,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Link2, { variant: "Linear" }),
    iconActive: createIconWrapper(Link2, { variant: "Bold" }),
};

export const documentationLinks: RouteItem = {
    name: "Documentation Links",
    id: ROUTES.ADMIN.documentationLinks.key,
    path: ROUTES.ADMIN.documentationLinks.key,
    component: DocumentationLinks,
    guard: AuthGuard,
    userTypes,
    roles,
    icon: createIconWrapper(Book, { variant: "Linear" }),
    iconActive: createIconWrapper(Book, { variant: "Bold" }),
};

export const adminRoutes: RouteItem[] = [
    overview,
    analytics,
    organizations,
    pmDashboard,
    messageCenter,
    reports,
    reportsSettings,
    organizationsView,
    organizationsFeature,
    organizationsFirebaseSettings,
    organizationsMobileAppAccounts,
    organizationsDefaultContentGenerator,
    appStoreMonitor,
    analyticsTenant,
    analyticsEvents,
    analyticsTenantEvents,
    permissions,
    users,
    usersView,
    portalUsers,
    rolesList,
    featureBundles,
    integrationTemplates,
    integrationTemplatesCreate,
    integrationTemplatesView,
    brands,
    announcements,
    announcementsCreate,
    announcementsEdit,
    announcementsMetrics,
    resourceLinks,
    documentationLinks,
    settings,
    logs,
    aiPlayground,
    imageGeneration,
    redisCache,
];
